import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative mt-26 flex max-h-[698px] w-full justify-center bg-gradient-to-r from-(--gradient-expert-review-from) from-10% to-(--gradient-expert-review-to) to-61% max-xl:px-5',
    wrap: 'flex w-[100%] max-w-360 gap-x-5.25 pt-22.5 max-xl:justify-center max-lg:mb-12.25 lg:pt-17 xl:pl-31.5',
    brandImage: 'hidden h-133 w-121.5 self-end lg:block',
    content: 'flex h-fit max-w-150 flex-col gap-6 lg:mt-32.5 lg:gap-10',
    title: 'text-[32px] leading-[1.2] font-semibold lg:text-[40px]',
    formWrap: 'flex flex-col gap-y-6 lg:gap-y-8',
    form: 'flex gap-6 max-lg:flex-col',
    button: 'w-fit text-base max-lg:w-fit lg:pr-9.5 lg:pl-9.5',
    disclaimer:
      'text-secondary-hover max-w-118 bg-transparent text-sm leading-[1.4] font-light underline-offset-4',
    approvalLink: 'link underline underline-offset-4',
    successMessage:
      'hidden text-5xl leading-[1.2] font-semibold whitespace-pre max-lg:text-center lg:text-[40px]',
    claims: ''
  },
  variants: {
    loginStatus: {
      guest: 'text-black',
      loggedIn: {
        base: 'mt-0! mb-10 bg-transparent p-0!',
        wrap: 'hidden',
        claims: 'relative translate-0 bg-transparent p-0 lg:p-0'
      }
    },
    formStatus: {
      default: '',
      error: '',
      success: {
        base: 'mt-17 max-lg:pt-22.5 max-lg:pb-34.25',
        content: 'max-lg:py-30 lg:mt-43.5',
        title: 'hidden',
        formWrap: 'hidden',
        successMessage: 'block'
      }
    },
    isSubscribed: {
      true: {
        base: 'my-10 bg-none max-md:mt-3'
      }
    }
  },
  defaultVariants: {
    loginStatus: 'guest',
    formStatus: 'default'
  }
});
